export default __webpack_public_path__ + "static/Plots0065-877d5f2e01790d994b40626657b4702f.jpg";